import Send from '@/config/api/index'

const userPath = "/v1/account"

function userApi(api, params) {
    return Send.post(userPath + api, params)
}

export default {
    regist() {
        return userApi('/userRegist')
    },
    list(params) {
        return userApi('/all', params)
    },
    save(params) {
        return userApi('/save', params)
    },
    saveLeave(params) {
        return userApi('/saveLeave', params)
    },
    getUserInfo() {
        return userApi( '/me')
    },
    updateUserInfo() {
        return userApi( '/refresh')
    },
    updateRole(params) {
        return userApi('/update/role', params)
    },
    updateScopes(params) {
        return userApi('/update/scopes', params)
    },
}
